import React, { useState } from 'react';
import { db } from '../../firebase';
import { collection, addDoc, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { toast } from 'react-toastify';

function CreateLabelModal({ isOpen, onClose }) {
  const [labelName, setLabelName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!labelName.trim()) return;

    try {
      setIsSubmitting(true);
      
      // Get the highest sorting value from existing labels
      const labelsQuery = query(
        collection(db, 'forumLabels'),
        orderBy('sorting', 'desc'),
        limit(1)
      );
      
      const labelsSnapshot = await getDocs(labelsQuery);
      let nextSorting = 10; // Default starting value
      
      if (!labelsSnapshot.empty) {
        const highestLabel = labelsSnapshot.docs[0].data();
        nextSorting = (highestLabel.sorting || 0) + 10;
      }
      
      const labelId = labelName.trim().toLowerCase().replace(/\s+/g, '-');
      
      await addDoc(collection(db, 'forumLabels'), {
        labelName: labelName.trim(),
        labelId,
        createdAt: new Date(),
        sorting: nextSorting
      });

      setLabelName('');
      onClose();
      toast.success('Label created successfully');
    } catch (error) {
      console.error('Error creating label:', error);
      toast.error('Failed to create label');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
          Create New Label
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Label Name
            </label>
            <input
              type="text"
              value={labelName}
              onChange={(e) => setLabelName(e.target.value)}
              placeholder="Enter label name"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              required
            />
          </div>
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Creating...' : 'Create Label'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateLabelModal;
